import { useEffect, useRef } from "react";
import styled from "styled-components";

export const HeaderInput = ({
    value = '',
    label,
    placeholder = '',
    onChange,
    textsize = 'md',
    padding = 'none', paddingLeft,paddingRight,
    margin = 'none', marginLeft, marginRight, marginTop, marginBottom,
}) => {

    const resolvedSpaces = {
        paddingLeft: paddingLeft ?? padding,
        paddingRight: paddingRight ?? padding,

        marginTop: marginTop ?? margin,
        marginBottom: marginBottom ?? margin,
        marginLeft: marginLeft ?? margin,
        marginRight: marginRight ?? margin,
    };

    const textareaRef = useRef(null);
    const resizeOnInput = () => {
        const el = textareaRef.current;
        if (!el) return;

        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
    };

    useEffect(() => {resizeOnInput()}, []);

    return (
        <StyledHeaderInput
            $paddingLeft={resolvedSpaces.paddingLeft}
            $paddingRight={resolvedSpaces.paddingRight}

            $marginTop={resolvedSpaces.marginTop}
            $marginBottom={resolvedSpaces.marginBottom}
            $marginLeft={resolvedSpaces.marginLeft}
            $marginRight={resolvedSpaces.marginRight}

            $textsize={textsize}
        >
            <textarea
                ref={textareaRef}
                spellCheck={false}
                rows={1}
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange?.(e.target.value)}
                onInput={resizeOnInput}
            />
            {
                label ? <div className="headerInputLabel">{label}</div> : null
            }
            
        </StyledHeaderInput>
    )
}

const StyledHeaderInput = styled.label`
    display: block;


    margin-top: ${({ theme, $marginTop }) => theme.spacing[$marginTop] || 0};
    margin-bottom: ${({ theme, $marginBottom }) => theme.spacing[$marginBottom] || 0};
    margin-left: ${({ theme, $marginLeft }) => theme.spacing[$marginLeft] || 0};
    margin-right: ${({ theme, $marginRight }) => theme.spacing[$marginRight] || 0};

    textarea
    {
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};

        padding-top: ${({ theme }) => theme.spacing.sm};
        padding-bottom: ${({ theme }) => theme.spacing.md};
        padding-left: ${({ theme, $paddingLeft }) => theme.spacing[$paddingLeft] || 0};
        padding-right: ${({ theme, $paddingRight }) => theme.spacing[$paddingRight] || 0};

        font-size: ${({theme, $textsize}) => theme.fontSize[$textsize] || theme.fontSize.md};
        font-weight: 500;
    }

    div.headerInputLabel
    {
        padding-top: ${({ theme }) => theme.spacing.xs};
        padding-left: ${({ theme, $paddingLeft }) => theme.spacing[$paddingLeft] || 0};
        padding-right: ${({ theme, $paddingRight }) => theme.spacing[$paddingRight] || 0};
        color: ${({theme}) => theme.colors.mutedForeground};
        
    }
`
